<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Admin">
      <!-- <b-card-text>Admin.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Employee -->
            <b-col cols="12">
              <b-form-group label="Employee" label-for="v-Employee">
                <validation-provider #default="{ errors }"  name="Employee">
                  <v-select id="v-Employee" v-model="form.select_1" placeholder="Chose Employee" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="employeeOptions" :reduce="employeeOptions => employeeOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Role -->
            <b-col cols="12">
              <b-form-group label="Role" label-for="v-Role">
                <validation-provider #default="{ errors }"  name="Role">
                  <v-select id="v-Role" v-model="form.select_2" placeholder="Chose Role" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="roleOptions" :reduce="roleOptions => roleOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- isSuperAdmin -->
            <b-col cols="2">
              <b-form-group label="isSuperAdmin" label-for="v-isSuperAdmin">
                <b-form-checkbox
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  v-model="form.checkbox_1"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="FileTextIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="FileTextIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- Username -->
            <b-col cols="12">
              <b-form-group label="Username" label-for="v-admin">
                <validation-provider #default="{ errors }"  name="Username" rules="required">
                  <b-form-input  id="v-Username" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Username" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Email -->
            <b-col cols="12">
              <b-form-group label="Email" label-for="v-admin">
                <validation-provider #default="{ errors }"  name="Email" rules="required">
                  <b-form-input  id="v-Email" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Email" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Password -->
            <b-col cols="12">
              <b-form-group label="Password" label-for="v-admin">
                <validation-provider #default="{ errors }"  name="Password" rules="required">
                  <b-form-input  id="v-Password" type="password" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Password" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Phone -->
            <b-col cols="12">
              <b-form-group label="Phone" label-for="v-admin">
                <validation-provider #default="{ errors }"  name="Phone" rules="required">
                  <b-form-input  id="v-Phone" :state="errors.length > 0 ? false:null" v-model="form.text_4" placeholder="Phone" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Pin -->
            <b-col cols="12">
              <b-form-group label="Pin" label-for="v-admin">
                <validation-provider #default="{ errors }"  name="Pin" rules="required">
                  <b-form-input  id="v-Pin" :state="errors.length > 0 ? false:null" v-model="form.text_5" placeholder="Pin" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormCheckbox,  BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, BFormCheckbox,  ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '', select_2: '', checkbox_1: '', text_1: '',text_2: '', text_3: '',text_4: '', text_5: ''},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ employeeOptions: state => state.employee.options, roleOptions: state => state.role.options})
  },
  created () {
    this.$store.dispatch('employee/getAll')
    this.$store.dispatch('role/getAll')
  },
  watch: {
		select_1 (obj) {
      return this.$store.dispatch('employee/getAll', obj)
		},
    select_2 (obj) {
      return this.$store.dispatch('role/getAll', obj)
		},
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('admin/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('admin/getById', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.empl_id
        this.form.select_2 = data.role_id
        this.form.checkbox_1 = data.type === 'A' ? true : false,
        this.form.text_1 = data.username
        this.form.text_2 = data.email
        this.form.text_3 = data.password
        this.form.text_4 = data.phone
        this.form.text_5 = data.pin
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>